const AGGREGATE_ARRIVALS_HEADERS = ['Date', 'Arrivals'];

export default AGGREGATE_ARRIVALS_HEADERS;
